const plugins = 'code preview importcss searchreplace autolink save directionality code visualblocks layout visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons'

export default plugins;
